import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Container, Grid } from "@material-ui/core";
import {
  ButtonHLPure,
  InputHLPure,
  SimpleLoading,
  ChatBoxGLPure,
} from "../../pures";

import "./follow-up-actions-contracts-discussion.css";
import FollowUpConfigurationsView from "./follow-up-actions-contracts-configuration.view";
import LabelPure from "../../pures/label/label.pure";

const FollowUpActionsContractsDiscussionView = (props) => {
  const {
    hideShowDetails,
    setShowDetails,
    setNameComponentUser,
    loading,
    usersChat,
    conversation,
    handleInputChange,
    createMessage,
    onMarkAsRead,
  } = props;

  const { t } = useTranslation();

  const [messageDiscussion, setMessageDiscussion] = useState("");

  const handleInputMessageDiscussion = (e) => {
    setMessageDiscussion(e.target.value);
  };

  const handleClickBack = () => {
    setShowDetails(false);
    setNameComponentUser("");
  };

  return (
    <div className="followUpActionsContractsDiscussionView-wrapper">
      {loading ? (
        <SimpleLoading />
      ) : (
        <div>
          <div className="followUpActionsContractsDiscussionView-discuss-container">
            <LabelPure
              title={t("followUpActionsContractsView.discuss.title")}
            />
            <div className="followUpActionsContractsDiscussionView-discussion-box">
              <h5>DISCUSION</h5>
            </div>
            <div className="followUpActionsContractsDiscussionView-btns-discussion-container">
              <Grid
                item
                lg={6}
                md={6}
                sm={12}
                xs={12}
                className="followUpActionsContractsDiscussionView-input-discussion"
              >
                <ChatBoxGLPure
                  user={usersChat}
                  conversation={conversation}
                  widthChat={1200}
                  heightChat={300}
                  placeholderChat={"Escribe algo"}
                  handleInputChange={handleInputChange}
                  createMessage={createMessage}
                  onMarkAsRead={onMarkAsRead}
                />
              </Grid>
            </div>
          </div>
          <ButtonHLPure
            nameBtn={t("button.return")}
            primary={true}
            onClickBtn={handleClickBack}
          />
        </div>
      )}
    </div>
  );
};

export default FollowUpActionsContractsDiscussionView;
